import {component} from '../form/Constant'
import {patientKeys} from '../patient/PatientConstants'

export const hospitalKeys = {
    basicInformation: 'basicInformation',
    groupBy: 'groupBy',
    name: 'name',
    description: 'description',
    hospitalNumber: 'hospitalNumber',

    hospitalLogo: 'hospitalLogo',
    logo: 'logo',
    displaySetting: 'displaySetting',

    contactInformation: 'contactInformation',
    address: 'address',
}

export const hospitalFilterList = [
    {
        key: hospitalKeys.contactInformation,
        children: [
            {
                key: patientKeys.address,
                hideHeader: true,
                component: component.address,
            },
        ],
    },
]

export const displaySettingOptions = [
    {value: 'none', label: 'None'},
    {value: 'imageOnly', label: 'Image Only'},
    {value: 'textOnly', label: 'Text Only'},
    {value: 'textAndImage', label: 'Text And Image'},
]

export const hospitalDisplaySettingType = {
    none: 'none',
    imageOnly: 'imageOnly',
    textOnly: 'textOnly',
    textAndImage: 'textAndImage',
}

export const hospitalList = [
    {
        key: hospitalKeys.basicInformation,
        description: ' Fill in the following information to create a hospital',
        required: true,
        children: [
            {
                key: hospitalKeys.groupBy,
                component: component.dropdown,
                placeholder:
                    'Leave this blank if this hospital is the main group',
            },
            {
                key: hospitalKeys.name,
                label: 'Hospital Name',
                component: component.inputText,
                placeholder: 'Field is required',
                required: true,
            },
            {
                key: hospitalKeys.nhsNumber,
                label: 'Hospital Number',
                component: component.inputText,
                placeholder: 'Field is required',
                required: true,
            },
            {
                key: hospitalKeys.description,
                component: component.inputText,
                placeholder: 'Optional',
            },
        ],
    },
    {
        key: hospitalKeys.hospitalLogo,
        description: `The required image ratio is 16:9`,
        children: [
            {
                key: hospitalKeys.logo,
                component: component.fileUpload,
                extraData: {
                    dimensionHeight: 16,
                    dimensionWidth: 9,
                },
            },
            {
                key: hospitalKeys.displaySetting,
                component: component.dropdown,
                placeholder:
                    'Select settings to display the hospital name and logo',
                options: displaySettingOptions,
                defaultValue: 'textOnly',
            },
        ],
    },
    {
        key: hospitalKeys.contactInformation,
        description: 'Fill in the hospital contact details.',
        note: '',
        required: true,
        children: [
            {
                key: hospitalKeys.address,
                hideHeader: true,
                component: component.address,
                className: 'col-12 grid  px-0',
                childrenClassName: 'md:col-6 col-12 px-1',
            },
        ],
    },
]

export const hospitalHiddenColumns = [
    {key: 'hospitalNumber'},
    {key: 'nhsNumber'},
    {key: 'numberOfPatients'},
    {key: 'numberOfHCP'},
    {key: 'addressLine1'},
    {key: 'addressLine2'},
    {key: 'addressLine3'},
    {key: 'addressLine4'},
    {key: 'city'},
    {key: 'state'},
    {key: 'country'},
    {key: 'postalCode'},
]
